import styled from 'styled-components'

import { COLOURS } from 'resources'

export const CategoryItem = styled.div`
  flex: ${({ columns }) => 1 / (columns || 1)};
  margin: 7px 5px;
  align-items: center;
  justify-content: center;
  min-height: 75px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  border: none;
`

export const CategoryIcon = styled.img`
  width: 50px;
  height: 50px;
`

export const CategoryName = styled.p`
  flex: 1;
  text-align: center;
  color: ${COLOURS.neutralBlack};
  font-family: 'EBGaramond', serif;
  font-size: 18px;
  line-height: 24px;
`
